export default class Popup {
  constructor(element) {
    this.element = element
    this.popup = document.getElementById(this.element.getAttribute("data-id"))

    this.popupBg = null
    let elem = this.popup

    while (elem !== document.body) {
      if (elem.classList.contains("contact-popup-bg")) {
        this.popupBg = elem
        break
      }
      elem = elem.parentNode
    }

    this.closeBtn = this.popup.querySelectorAll(".js-popup-close")
    if (this.element === null && this.popup === null) {
      return
    }
    this.element.addEventListener("click", (e) => {
      e.preventDefault()
      this.open()
    })
    if (this.popupBg) {
      this.popupBg.addEventListener("click", () => {
        this.close()
      })
    }
    for (const item of this.closeBtn) {
      item.addEventListener("click", (e) => {
        e.preventDefault()
        this.close()
      })
    }

    this.popup.addEventListener("click", (e) => {
      e.stopPropagation()
    })

    this.popup.addEventListener("toggleResize", () => {
      this.popupTopOffset()
    })
    window.addEventListener("resize", () => {
      this.popupTopOffset()
    })
  }

  open() {
    //lightbox.changeBg('rgba(0,0,0,.8)');
    if (this.popupBg) {
      this.popupBg.classList.add("open")
    }
    //lightbox.open();
    this.popup.classList.add("open")
    this.popupTopOffset()
    // for (let slider of window.sliders) {
    //   slider.update();
    // }
  }

  close() {
    //lightbox.close();
    //lightbox.restoreDefaults();
    this.popup.classList.remove("open")
    if (this.popupBg) {
      this.popupBg.classList.remove("open")
    }

    const closeEvent = new CustomEvent("popupClose", {})
    this.popup.dispatchEvent(closeEvent)
  }

  popupTopOffset() {
    let scrollTop = Math.floor((window.innerHeight - this.popup.offsetHeight) / 2)
    scrollTop = scrollTop < 0 ? 0 : scrollTop
    this.popup.style.top = `${scrollTop}px`
  }
}

for (const toggle of document.querySelectorAll(".popup-toggle")) {
  toggle.popup = new Popup(toggle)
}



// WEBPACK FOOTER //
// ./src/blocks/contacts/contacts.js